export enum PlaceholderAction {
  AddTextPlaceholder = 'addTextPlaceholder',
  AddSignaturePlaceholder = 'addSignaturePlaceholder',
}
